// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorToolbar-module__TopToolbarContainer {
  max-height: 50px;
  padding: 10px;
  border: 1px solid #e8e8e8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./app/pages/HR/HRSettings/PeopleTableEditor/PeopleTableEditorToolbar.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".TopToolbarContainer {\n  max-height: 50px;\n  padding: 10px;\n  border: 1px solid #e8e8e8;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TopToolbarContainer": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorToolbar-module__TopToolbarContainer`
};
export default ___CSS_LOADER_EXPORT___;
